import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/Icons/Grey/Chevron Down.svg'


const _withScopeId = n => (_pushScopeId("data-v-2c92ddf7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filter-bar-time" }
const _hoisted_2 = {
  key: 0,
  class: "date-range",
  "data-test-tag": "filter-custom-date-range"
}
const _hoisted_3 = {
  key: 0,
  class: "ts-date-select"
}
const _hoisted_4 = { class: "filter-bar-dates" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_6 = ["data-test-tag", "onClick"]
const _hoisted_7 = {
  key: 1,
  class: "asknicely-icon-loader_static"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DateRangeInput = _resolveComponent("DateRangeInput")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_FilterModalMobileHeader = _resolveComponent("FilterModalMobileHeader")!
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showDateInput)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_DateRangeInput, {
            from: _ctx.displayDate.from,
            to: _ctx.displayDate.to,
            "on-change": _ctx.setDateRange,
            "start-open": _ctx.startOpen
          }, null, 8, ["from", "to", "on-change", "start-open"])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.showDateInput || !_ctx.tsMobileView)
      ? (_openBlock(), _createBlock(_component_Dropdown, {
          key: 1,
          ref: "dropdown",
          modal: _ctx.tsMobileView,
          disabled: !_ctx.hasNetworkConnection
        }, {
          trigger: _withCtx(() => [
            (_ctx.tsMobileView && _ctx.theFilterTimeLabel == 'custom')
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.formatDates()), 1),
                  _hoisted_5
                ]))
              : (_openBlock(), _createBlock(_component_BaseButton, {
                  key: 1,
                  secondary: "",
                  muted: "",
                  disabled: !_ctx.hasNetworkConnection,
                  icon: _ctx.hasNetworkConnection ? 'chevron-down' : '',
                  class: "button-trigger",
                  "data-test-tag": "filter-time-button"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.theFilterTimeLabel), 1)
                  ], undefined, true),
                  _: 1
                }, 8, ["disabled", "icon"]))
          ]),
          content: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(["columns options", {
                        'ts-modal-c': _ctx.tsMobileView,
                        'new-options': !_ctx.tsMobileView,
                    }])
            }, [
              (_ctx.tsMobileView)
                ? (_openBlock(), _createBlock(_component_FilterModalMobileHeader, {
                    key: 0,
                    title: "Time Filter",
                    onClose: _ctx.closeModal
                  }, null, 8, ["onClose"]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterTimeOptions, (optionSet, indexSet) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: indexSet,
                  class: _normalizeClass(_ctx.getOptionSetClass(indexSet))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionSet, (option, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: option.label,
                      class: _normalizeClass([
                                _ctx.getIsGreyOption(indexSet, index)
                                    ? 'grey-option'
                                    : 'option',
                                'capitalized',
                            ]),
                      "data-test-tag": `filter-time-option-${option.time_unit}-${option.time_value}`,
                      onClick: 
                                () => _ctx.setTimeOption(option, indexSet, index)
                            
                    }, _toDisplayString(option.label), 11, _hoisted_6))
                  }), 128))
                ], 2))
              }), 128)),
              (_ctx.filterPatching)
                ? (_openBlock(), _createElementBlock("i", _hoisted_7))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          _: 1
        }, 8, ["modal", "disabled"]))
      : _createCommentVNode("", true)
  ]))
}